import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { CarteraService } from 'app/services/cartera/cartera.service';

@Component({
  selector: 'app-add-cobro-fijo',
  templateUrl: './add-cobro-fijo.component.html',
  styleUrls: ['./add-cobro-fijo.component.scss']
})
export class AddCobroFijoComponent implements OnInit {

  newForm: FormGroup;


  /**
   * Constructor
   * 
   * @param _data 
   * @param {MatDialogRef<AddCobroFijoComponent>} _dialog 
   * @param {CarteraService} _cartera 
   * @param {MatSnackBar} _snackBar 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) private _data, 
    public _dialog: MatDialogRef<AddCobroFijoComponent>,
    private _cartera: CarteraService,
    private _snackBar: MatSnackBar
  ) { }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this.newForm = this.createForm();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Creación del FormGroup
   */
  createForm(): FormGroup {
    return new FormGroup({
      diaCobro: new FormControl('', [
        Validators.required,
        Validators.min(1),
        Validators.max(31)
      ]),
      confirmLlamada: new FormControl(false),
      diaLlamada: new FormControl(1, [
        Validators.min(1),
        Validators.max(5),
      ]),
      userCreador: new FormControl(JSON.parse(localStorage.getItem('usuario'))['id_usuario'])
    });
  }
  
  /**
   * Añade Cobro Fijo al grupo
   * @param {Array<object>} form 
   */
  addCobroFijo(form: Array<object>): void {
    this._cartera.AgregarCobroFijo(this._data.database, this._data.grunit, this._data.grugru, form).subscribe((data: any) => {
      // Si hubo filas cambiadas se muestra un mensaje y cierra el modal, de lo contrario muesta un mensaje de error
      if(data.changedRows == 1){
        this._snackBar.open('Cobro Fijo Agregado', 'Aceptar', {
          duration: 2000
        });
        this._dialog.close(true);
      }else{
        this._snackBar.open('Error: Cobro fijo no agregado', '', {
          duration: 2000,
          panelClass: ['warn-600']
        });
      }
    })
  }



}
